import React, { useMemo } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Button, Typography } from '@mui/material';
import Config from '../../../../../../config';
import { ReactComponent as WindowsIcon } from '../icons/windows_icon.svg';
import useStyles from './useStyles';

export type DownloadWindowsAppProps = {
  focus?: boolean;
};

export const DownloadWindowsApp = ({
  focus = false
}: DownloadWindowsAppProps): JSX.Element => {
  const classes = useStyles({ focus });
  const { formatMessage } = useIntl();

  const downloadDesktopWindowsAppValues = useMemo(
    () => ({
      variant: formatMessage({
        id: 'appMenu.windowsOs'
      })
    }),
    [formatMessage]
  );

  const windowsOsVersion = useMemo(
    () => ({ version: Config.desktopSupportedOSVersions.windows }),
    []
  );

  const windowsButtonIcon = useMemo(
    () => (
      <WindowsIcon className={classes.icon} fill={focus ? '#fff' : '#626262'} />
    ),
    [classes.icon, focus]
  );

  const buttonClasses = useMemo(
    () => ({
      startIcon: classes.icon,
      root: classes.button
    }),
    [classes.icon, classes.button]
  );
  return (
    <Button
      data-testid="windows-app-download"
      variant={focus ? 'contained' : 'outlined'}
      color={focus ? 'primary' : 'inherit'}
      startIcon={windowsButtonIcon}
      classes={buttonClasses}
      href={Config.downloads.windows}
    >
      <div className={classes.buttonContentContainer}>
        <Typography className={classes.buttonText} variant="body1">
          <FormattedMessage
            id="appMenu.downloadDesktopApp"
            values={downloadDesktopWindowsAppValues}
          />
        </Typography>
        <Typography className={classes.buttonText} variant="caption">
          <FormattedMessage id="appMenu.requires" values={windowsOsVersion} />
        </Typography>
      </div>
    </Button>
  );
};

export default DownloadWindowsApp;
